// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"34":"category","42":"impressum","443":"about","631":"contact","850":"galery"}[chunkId] + "." + {"34":"5f9063e3","42":"e6bc0677","443":"a60b67e9","631":"23042192","850":"2ffc7ad8"}[chunkId] + ".css";
};